(() => {
  function initialize() {
    document.querySelectorAll('.mobile-site-nav__icon').forEach(button => {
      if (button.dataset.hrInitialized) return;
      button.dataset.hrInitialized = 'true';
      const update = () => button.setAttribute('aria-expanded', String(button.classList.contains('submenu-open')));
      new MutationObserver(update).observe(button, {attributes:true, attributeFilter:['class']});
      const submenu = button.nextElementSibling;
      if (submenu) {
        submenu.id ||= 'HRMobileSubmenu-' + Array.from(document.querySelectorAll('.mobile-site-nav__icon')).indexOf(button);
        button.setAttribute('aria-controls', submenu.id);
        button.closest('li')?.addEventListener('keydown', event => {
          if (event.key !== 'Escape' || !button.classList.contains('submenu-open')) return;
          event.preventDefault();
          event.stopPropagation();
          button.click();
          button.focus();
        });
      }
      update();
    });
    document.querySelectorAll('.header-navigation').forEach(panel => {
      if (panel.dataset.hrFocusReady) return;
      const header = panel.closest('.site-header');
      const launcher = header?.querySelector('.js-mobile-menu-icon');
      const close = panel.querySelector('.js-close-mobile-menu');
      if (!launcher || !close) return;
      panel.dataset.hrFocusReady = 'true';
      panel.id ||= 'HRMobileNavigation-' + header.dataset.sectionId;
      launcher.setAttribute('aria-controls', panel.id);
      const mobile = matchMedia('(max-width: 939px)');
      let wasOpen = false;
      const focusable = () => Array.from(panel.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')).filter(element => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
      const update = () => {
        const open = mobile.matches && panel.classList.contains('header-navigation--open');
        launcher.setAttribute('aria-expanded', String(open));
        if (mobile.matches) panel.setAttribute('aria-hidden', String(!open));
        else panel.removeAttribute('aria-hidden');
        if (open && !wasOpen) close.focus();
        if (!open && wasOpen && panel.contains(document.activeElement)) launcher.focus();
        wasOpen = open;
      };
      panel.addEventListener('keydown', event => {
        if (!wasOpen) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          close.click();
          launcher.focus();
        } else if (event.key === 'Tab') {
          const controls = focusable();
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault(); last?.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault(); first?.focus();
          }
        }
      });
      new MutationObserver(update).observe(panel, {attributes:true,attributeFilter:['class']});
      mobile.addEventListener('change', () => {
        if (!mobile.matches && panel.classList.contains('header-navigation--open')) close.click();
        update();
      });
      update();
    });
    document.querySelectorAll('.hr-nav-toggle').forEach(button => {
      if (button.dataset.hrInitialized) return;
      button.dataset.hrInitialized = 'true';
      const item = button.closest('.site-nav__item');
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!item || !panel) return;
      const update = () => button.setAttribute('aria-expanded', String(item.classList.contains('open')));
      const close = () => {item.classList.remove('open'); update();};
      button.addEventListener('click', event => {
        event.preventDefault(); event.stopPropagation();
        const open = button.getAttribute('aria-expanded') !== 'true';
        document.querySelectorAll('.hr-nav-toggle[aria-expanded="true"]').forEach(other => {
          if(other !== button) {other.closest('.site-nav__item').classList.remove('open');other.setAttribute('aria-expanded','false');}
        });
        item.classList.toggle('open', open); update();
      });
      item.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault(); event.stopPropagation(); close(); button.focus();
        } else if (event.key === 'ArrowDown' && event.target === button) {
          event.preventDefault(); item.classList.add('open'); update(); panel.querySelector('a')?.focus();
        }
      });
      item.addEventListener('focusout', event => {if(!item.contains(event.relatedTarget)) close();});
      document.addEventListener('click', event => {if(!item.contains(event.target)) close();});
      new MutationObserver(update).observe(item,{attributes:true,attributeFilter:['class']});
      update();
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
